
import {UIGameEventDiceView} from '../../../../../shared/scripts/ui_game/ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIGameEventDiceView'
import {UIGameEventDiceController} from '../../../../../shared/scripts/ui_game/ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIGameEventDiceController'
import {UIGameDiceView} from '../../../../../shared/scripts/ui_game/ui_game_dice/UIGameDiceView'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'

export class UIMGameEventDiceController extends UIGameEventDiceController {
    protected initializeOpponentDiceViews() {
        this.opponentDiceViews = []

        const playersController = this.uiGameManager.playersController
        if(!playersController) return

        const playerViewWidth = playersController.playerInformationViews[0].width
        const playerViewHeight = playersController.playerInformationViews[0].height

        const opponentDiceSize = playerViewHeight / 3
        const margin = opponentDiceSize * 0.125
        const baseDiceY = -opponentDiceSize * 0.5 - margin
        let index = 1

        for(const playerView of playersController.playerInformationViews) {
            if(playerView.player.color == this.uiGameManager.gameController.myColor) continue
            const isPlayerOnLeft = UIUtilsEjsVariables.isUserOnTabletApp ? false : (playerView.position.x < this.uiGameManager.canvasController.appW / 2)
            const baseDiceX = isPlayerOnLeft ? playerViewWidth + margin * 1.25 : -opponentDiceSize - margin * 1.25

            const opponentDice = new UIGameEventDiceView(this.uiGameManager, this.eventDiceState, baseDiceX, baseDiceY, opponentDiceSize, playerView, false)
            opponentDice.tintPassive()
            opponentDice.hide()
            this.opponentDiceViews.push(opponentDice)
            index += 1
        }
    }

    protected getOpponentDiceViewToDisplay(currentTurnPlayerIndex: number, opponentCount: number): UIGameDiceView {
        return this.opponentDiceViews[currentTurnPlayerIndex]
    }
}
